import {
  AccordionModule,
  CheckboxModule,
  ConfirmDialogModule,
  DropdownModule,
  FileUploadModule,
  InputTextModule,
  StepsModule,
  ToastModule,
  EditorModule,
  ProgressSpinnerModule,
  PaginatorModule,
  InputSwitchModule,
  TooltipModule,
  RadioButtonModule,
  ButtonModule,
  DialogModule,
} from 'primeng';
import { QuillModule } from 'ngx-quill';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationService } from 'primeng/api';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
//components
import { LoaderComponent } from './components/loader/loader.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { CompanyDataComponent } from './components/company-data/company-data.component';
import { OrderHistoryComponent } from './components/order-history/order-history.component';
import { LockUnlockComponent } from './components/lock-unlock-buttons/lock-unlock.component';
import { SectionHeaderComponent } from './components/section-header/section-header.component';
import { SectionCommentComponent } from './components/section-comment/section-comment.component';
import { TechnicianInfoComponent } from './components/technician-info/technician-info.component';
import { ApplicationStepsComponent } from './components/application-steps/application-steps.component';
import { PersonDataFieldsComponent } from './components/person-data-fields/person-data-fields.component';
import { ConfirmationModalComponent } from './components/confirmation-modal/confirmation-modal.component';
//services
import { EnvironmentService } from '../services/environment.service';
import { NetzTranslationLoader } from '../services/netz-translation-loader';
//directives
import { IbanValidDirective } from './directives/iban-valid.directive';
import { EmailValidDirective } from './directives/email-valid.directive';
import { StringMatchDirective } from './directives/string-match.directive';
//others
import { StringifiedDatePipe } from './pipes/stringified-date.pipe';
import { PendingChangesGuard } from './guards/pending-changes-guard.servie';
import { ErrorHandlingModule } from '../+error-handling/error-handling.module';
import { CustomFieldsComponent } from './custom-fields/custom-fields.component';

@NgModule({
  declarations: [
    ApplicationStepsComponent,
    PersonDataFieldsComponent,
    FileUploadComponent,
    LockUnlockComponent,
    OrderHistoryComponent,
    LoaderComponent,
    SectionCommentComponent,
    StringifiedDatePipe,
    CustomFieldsComponent,
    StringMatchDirective,
    EmailValidDirective,
    IbanValidDirective,
    SectionHeaderComponent,
    ConfirmationModalComponent,
    TechnicianInfoComponent,
    CompanyDataComponent,
  ],
  imports: [
    ConfirmDialogModule,
    PaginatorModule,
    ProgressSpinnerModule,
    AccordionModule,
    CommonModule,
    StepsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    DropdownModule,
    InputTextModule,
    InputSwitchModule,
    TooltipModule,
    RadioButtonModule,
    EditorModule,
    FileUploadModule,
    CheckboxModule,
    ToastModule,
    ButtonModule,
    ErrorHandlingModule,
    DialogModule,
    QuillModule.forRoot(),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useClass: NetzTranslationLoader,
        deps: [HttpClient, EnvironmentService],
      },
    }),
  ],
  exports: [
    ApplicationStepsComponent,
    PersonDataFieldsComponent,
    FileUploadComponent,
    LockUnlockComponent,
    OrderHistoryComponent,
    LoaderComponent,
    SectionCommentComponent,
    CustomFieldsComponent,
    StringifiedDatePipe,
    StringMatchDirective,
    EmailValidDirective,
    IbanValidDirective,
    SectionHeaderComponent,
    ConfirmationModalComponent,
    TechnicianInfoComponent,
    CompanyDataComponent,
  ],
  providers: [EnvironmentService, ConfirmationService, PendingChangesGuard],
})
export class SharedModule {}
